import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import notificationService from './notification.service';

export interface NotificationState {}

const NotificationStore: Module<NotificationState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async getPreview(
         context,
         {
            medium_type,
            shift_ids,
            candidate_pool_id,
            slot_state_key,
            message,
            type,
            pool_id,
            board_id,
         }: {
            medium_type: string;
            shift_ids: number[];
            candidate_pool_id: number;
            slot_state_key: string;
            message: string;
            type: string;
            pool_id?: number | string;
            board_id?: number | string;
         },
      ) {
         return await notificationService
            .getPreview({ medium_type, shift_ids, candidate_pool_id, slot_state_key, message, type, pool_id, board_id })
            .then((response) => response);
      },
   },
};

export default NotificationStore;
